import Debug from 'debug';
const debug = Debug(`knack.core.utility.getSolrType`);
export const getSolrType = (field_type, format) => {
    let type;
    switch (field_type) {
        case `currency`:
        case `number`:
        case `auto_increment`:
        case `count`:
        case `sum`:
        case `min`:
        case `max`:
        case `average`:
        case `timer`:
        case `rating`:
            type = `number`;
            break;
        case `date_time`:
            type = `date`;
            break;
        case `equation`:
            type = `number`;
            if (format && format.equation_type && format.equation_type === `date` && format.date_result && format.date_result === `date`) {
                type = `date`;
            }
            break;
        case `link`:
            if (format && format.text_format && (format.text_format === `same` || format.text_format === `unique`)) {
                type = `label_text`;
            }
            else {
                type = `url_text`;
            }
            break;
        default:
            type = `text`;
            break;
    }
    return type;
};
